import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs: [string, string][] = [['¿En qué formato recibo el material?', 'En PDF de alta calidad, listo para imprimir y usar en digital.'], ['¿Para qué edades sirve?', 'Para secundaria, de 13 a 18 años, con un tomo por año.'], ['¿Puedo imprimirlo y usarlo con todos mis grupos?', 'Sí, lo usas cuantas veces quieras en tu aula.'], ['¿Incluye las respuestas de las evaluaciones?', 'Sí, cada tomo trae solucionario para el docente.'], ['¿Cómo accedo después de comprar?', 'Recibes la descarga al instante, apenas confirmas el pago.'], ['¿Tiene garantía?', 'Sí, cuentas con 7 días de garantía de devolución.']];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-47" data-mp="2z9omu5ob904r">
      <Reveal className="mx-auto max-w-3xl" data-id="element-48" data-mp="2zc1amzgr24pq">
        <div className="mb-12 text-center" data-id="element-49" data-mp="1vp9es0ka0aeh">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-50" data-mp="1vq10mjo2mtrk">BUENO SABERLO</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-51" data-mp="1rq0lewt5eejg">Preguntas frecuentes</h2>
        </div>
        <div className="space-y-3" data-id="element-52" data-mp="25hf93gy033wu">
          {faqs.map(([question, answer], index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-blue/[0.06] bg-brand-alt" data-id="element-53" data-mp="2aent7n2pli0q" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold text-brand-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange" data-id="element-54" data-mp="2oeyiwmsa8qkb">
                  <span data-id="element-55" data-mp="2p5et6611p9mu">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-56" data-mp="2u3q6wrugo4ac" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-57" data-mp="2z0gip2z8gdpy" />}
                </button>
                <AnimatePresence initial={false} data-id="element-58" data-mp="382psfqmog32a">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-59" data-mp="380lppc0ila3l">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-60" data-mp="3qu8u9u4ytb2q">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}